export default "__VITE_ASSET__Dfpp0dhE__"